var tick = "https://shopfront-cdn.tekoapis.com/static/df90022c2d1adbfb.svg";

export { tick as default };
